// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { useIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';

export function ChooseAnotherMethodMessage(): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);
  switch (country) {
    case 'br':
      return <Root>Escolha um outro método para concluir o pagamento.</Root>;

    case 'ar':
    case 'bo':
    case 'cl':
    case 'co':
    case 'ec':
    case 'mx':
    case 'pe':
    case 'uy':
    case 'py':
    case 'pa':
    case 'sv':
    case 'gt':
    case 'do':
    case 'cr':
      return <Root>Elige otro método para completar el pago.</Root>;

    case 'za':
    case 'ke':
    case 'ng':
    case 'in':
    case 'tz':
    case 'ug':
    case 'zm':
    case 'eg':
    case 'gh':
    case 'jm':
      return <Root>Choose another payment method to complete the payment.</Root>;

    default:
      throw new Error(`Retry message: no translation found for country ${country}`);
  }
}

const Root = styled.p`
  text-align: center;
`;
